( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.login-button' ).click( function() {
        const memberNumber = '2112018460';
        const zipCode = '60000';
        _this.login( memberNumber, zipCode );
      } );
    },
    finalize: function() {
    },
    login: function( memberNumber, zipCode ) {
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'login_to_ticketure',
            params: {
              member_number: memberNumber,
              zip_code: zipCode,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              if ( data.response ) {
                alert( 'logged in' );
              } else {
                alert( 'error logging in' );
              }
            }
          }
      );
    },
  };
  app.registerComponent( 'ticketure', COMPONENT );
} )( app );
